import React from "react";
import { TimePicker } from "../../components/antOverrides";
import moment from "moment";

const useTimePickerLogic = (props) => {
  const { onChange, onSelect, disabledHours, disabledMinutes } = props;

  const disabledTime = () => ({
    disabledHours: () => disabledHours && disabledHours(),
    disabledMinutes: (selectedHour) =>
      disabledMinutes && disabledMinutes(selectedHour),
  });

  const isValidTime = (selectedTime) => {
    const selectedHour = selectedTime.hour();
    const selectedMinute = selectedTime.minute();
    const disabledHoursArr = disabledHours && disabledHours();
    const disabledMinutesArr = disabledMinutes && disabledMinutes(selectedHour);

    if (disabledHoursArr && disabledHoursArr.includes(selectedHour)) {
      return false;
    }

    if (disabledMinutesArr && disabledMinutesArr.includes(selectedMinute)) {
      return false;
    }

    return true;
  };

  const handleChange = (selectedTime) => {
    if (selectedTime && isValidTime(selectedTime)) {
      onChange(selectedTime);
    }
  };

  const handleSelect = (selectedTime) => {
    if (selectedTime && isValidTime(selectedTime)) {
      onSelect(selectedTime);
    }
  };

  return { disabledTime, handleChange, handleSelect, isValidTime };
};

const RegularTimePicker = (props) => {
  const { value, format, ...rest } = props;
  const { disabledTime, handleChange, handleSelect } =
    useTimePickerLogic(props);

  return (
    <TimePicker
      {...rest}
      disabledTime={disabledTime}
      value={value}
      format={format}
      onChange={handleChange}
      onSelect={handleSelect}
    />
  );
};

const InlineTimePicker = (props) => {
  const { value, format, typingFormat, ...rest } = props;
  const { disabledTime, handleChange, handleSelect, isValidTime } =
    useTimePickerLogic(props);

  const onFocus = () => {
    document.activeElement.select();
  };

  return (
    <TimePicker
      {...rest}
      disabledTime={disabledTime}
      value={value}
      format={format}
      onChange={handleChange}
      onSelect={handleSelect}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          const pickerValue = moment(e.target.value, typingFormat, true);
          if (pickerValue.isValid() && isValidTime(pickerValue)) {
            const val =
              e.target.value.substring(0, 2) +
              ":" +
              e.target.value.substring(2);
            handleChange(moment(val, format, true));
          }
        }
      }}
      open={false}
      onFocus={onFocus}
    />
  );
};

const CustomTimePicker = (props) => {
  const { disablePicker, ...otherProps } = props;
  return disablePicker ? (
    <InlineTimePicker {...otherProps} />
  ) : (
    <RegularTimePicker {...otherProps} />
  );
};

export default CustomTimePicker;
